import React from 'react';
import Button from '~/components/Dynamic/Button';

const Buttons = ({ blok, className, ...other }) => {
  return (
    <div className={`buttons flex items-center flex-wrap -ml-8 ${className}`} {...other}>
      {blok?.map((btn) => (
        <div key={`button-wrapper-${btn._uid}`} className="pl-8">
          <Button blok={btn} />
        </div>
      ))}
    </div>
  );
};

export default Buttons;
